import React from 'react';
import { styled } from '@mui/material/styles';
import { AspectRationProps } from './aspect-ration.interfact';

const PREFIX = 'AspectRatioDefault';

const classes = {
  aspect: `${PREFIX}-aspect`,
  container: `${PREFIX}-container`,
};

const Root = styled('div')<AspectRationProps>(({ height, width, ratio }) => ({
  height: height || 'auto',
  width: width || '100%',
  overflow: 'hidden',

  [`& .${classes.aspect}`]: {
    paddingTop: `calc(1 / ${ratio} * 100%)`,
    position: 'relative',
    backgroundColor: 'transparent',
  },

  [`& .${classes.container}`]: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    overflow: 'hidden',
  },
}));

export const AspectRatioDefault: React.FC<AspectRationProps> = (
  props: AspectRationProps
) => {
  const { children, ratio, ...rest } = props;

  return (
    <Root ratio={ratio} {...rest}>
      {ratio ? (
        <div className={classes.aspect}>
          <div className={classes.container}>{children}</div>
        </div>
      ) : (
        <>{children}</>
      )}
    </Root>
  );
};

export default AspectRatioDefault;
